import ObjectType from './ObjectType';
const BooleanType = Object.seal({
    fullName: 'Boolean',
    name: 'Boolean',
    namespace: '',
    baseType: ObjectType,
    isArray: false,
    factory: Boolean,
});
export default BooleanType;
